// extracted by mini-css-extract-plugin
module.exports = {"label":"DonationSelect_label__3cHZk"};